import { ISearchResult, IResults, IErrorType } from '../state-helpers/search-results';
import { IFacetResult } from '../state-helpers/facets';
import { GlobalActionType } from '../../global/actions/index';

// Enums
export class ActionType extends GlobalActionType {
    static SET_PAGE: string = "SET_PAGE";
    static SET_SEARCH_TERM: string = "SET_SEARCH_TERM";
    static RESULTS_LOADED: string = "RESULTS_LOADED";
}

// Interfaces
export interface IAction {
    type: ActionType;
}

export interface IResultsLoadedAction extends IAction {
    results: ISearchResult[];
    facets: IFacetResult[];
    page: number;
    errorMessage: string;
    errorType: IErrorType;
    totalNumber: number;
    totalPages: number;
    trackingId: string;
    showResults?: boolean;
    isLoading?: boolean;
    suggestion: string;
    fromAutocomplete: boolean;
}

export interface ISetSearchTermAction extends IAction {
    searchTerm: string;
}

// Actions
export function noResults(): IResultsLoadedAction {
    return {
        type: ActionType.SET_PAGE,
        facets: [],
        results: [],
        page: 1,
        errorMessage: '',
        totalNumber: 0,
        totalPages: 0,
        trackingId: '',
        suggestion: '',
        errorType: IErrorType.NONE,
        fromAutocomplete: false
    }
}

export function setSearchTerm(searchTerm: string): ISetSearchTermAction {
    return {
        type: ActionType.SET_SEARCH_TERM,
        searchTerm
    };
}
